module.exports = __webpack_public_path__ + "static/media/IconVotingInactive.3f0d63cf.svg";